<p-card [header]="theme.name" styleClass="p-card-shadow">
  <p-header [vnmTheme]="theme">
    <div class="theme-pallette">
      <div class="pallette-swatch"></div>
      <div class="pallette-swatch"></div>
      <div class="pallette-swatch"></div>
      <div class="pallette-swatch"></div>
    </div>
  </p-header>
  <p>{{ theme.description }}</p>
  <p-footer class="p-actions-group">
    <button
      pButton
      type="button"
      [label]="'theme-card.edit' | translate"
      icon="fa fa-pencil-alt"
      [routerLink]="['/theming', theme.id]"
    ></button>
  </p-footer>
</p-card>
